module.exports = __webpack_public_path__ + "static/media/textured_paper.3c0f6fd6.png";